import axios from "./axios";
let token = null
class http {
    constructor(option) {
        this.instance = axios.create({
             baseURL: 'https://qk-api.halawateam.com',
            // baseURL: 'http://120.79.172.58:220',
            timeout: 5000,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        this.init()
    }

  post (url, params) {
    return new Promise((resolve, reject) => {
      this.instance.post(url, { ...params }).then(res => {
        const { message } = res;
        // if (message == 'success') {
        resolve(res)
        // } else {
        //     reject()
        // }

      }).catch(() => {
        reject()
      })
    })

  }

  init () {
    this.interceptorsRequest()
    this.interceptorsResponse()
  }

  interceptorsRequest () {
    // 请求拦截器
    this.instance.interceptors.request.use(config => {
      // 在发送请求之前做些什么
      // 可以在此处添加token等认证信息
      config.headers = {
        ...config.headers,
        'app-token': token,
        'app-version': '1.7.3',
        'language': 'en'
      }
      return config;
    }, error => {
      // 对请求错误做些什么
      return Promise.reject(error);
    });
  }
  interceptorsResponse () {
    // 响应拦截器
    this.instance.interceptors.response.use(response => {
      // 对响应数据做些什么
      return {
        ...response.data,
        responseText: response.request.responseText
      };
    }, error => {
      // 对响应错误做些什么
      return Promise.reject(error);
    });
  }
}

export const request = new http()



export const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
export const isHuawei = /huawei|Huawei|HUAWEI/.test(navigator.userAgent)
export const isChrome = navigator.userAgent.includes('Chrome') && 
                            !navigator.userAgent.includes('Edge') && 
                            !navigator.userAgent.includes('OPR') ;


export function getUrlParams () {
   const paramsRegex = /[?&]+([^=&]+)=([^&]*)/gi;
  const params = {};
  let match;
  while (match = paramsRegex.exec(location.href)) {
    params[match[1]] = match[2];
  }
 
  return params;
}
export function formatNumber (num,defult=0) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(2).replace(/\.0{1,2}$/, '') + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(2).replace(/\.0{1,2}$/, '') + 'K';
  }
  if (num) {
    return (num || 0).toString()
  }
  return defult;
}

export function showToast (message) {
  // 创建div元素
  const toast = document.createElement('div');
  toast.textContent = message;

  // 设置样式
  toast.style.position = 'fixed';
  toast.style.top = '50%';
  toast.style.left = '50%';
  toast.style.backgroundColor = 'rgba(0,0,0,.8)';
  toast.style.color = 'white';
  toast.style.padding = '15px';
  toast.style.borderRadius = '5px';
  toast.style.transform = 'translate(-50%,-50%)';
  toast.style.fontSize = '14px';
  toast.style.zIndex = '1000';
  toast.style.opacity = '0';


  // 将toast添加到body中
  document.body.appendChild(toast);

  // 显示toast并在一段时间后消失
  toast.style.opacity = '1';
  setTimeout(() => {
    toast.style.opacity = '0';
    setTimeout(() => {
      document.body.removeChild(toast);
    }, 500); // 延迟500毫秒后从DOM中移除toast
  }, 3000); // 延迟3000毫秒后消失
}

window.getToken = function (t) {
  token = t
}
var index = 0
export const getTokenFn = () => {

  return new Promise((resolve, reject) => {

    if (window.tokenTime) {
      reject()
    }

    if (isiOS) {
      window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getToken.postMessage('')
    }
    window.tokenTime = setInterval(() => {
      if (!isiOS) {
        try {
          token = window.YiYaJsObj.getToken()

        } catch (error) {

        }
      }
      if (token) {
        clearInterval(window.tokenTime)
        window.tokenTime = null
        resolve()
      }
      index++
      if (index > 20) {
        token = 'ac26bbfb-0e29-4580-8630-3404cc52ed49'
        clearInterval(window.tokenTime)
        window.tokenTime = null
        resolve()
      }

    }, 100)

  })
}

// 关闭页面
export const closePage = () => {
  try {
    if (isiOS) {
      window.webkit.messageHandlers.closePage.postMessage('')
    } else {
      window.YiYaJsObj.closePage()
    }

  } catch (error) {
    window.history.go(-1)
  }
}


// 跳转充值
export const openPay = () => {
  try {
    if (isiOS) {
      window.webkit.messageHandlers.openPay.postMessage('')
    } else {
      window.YiYaJsObj.openPay()
    }

  } catch (error) {
    window.history.go(-1)
  }
}


// 跳转充值
export const openRoom = (roomId, roomCode) => {
  try {
    if (isiOS) {
      window.webkit.messageHandlers.openRoom.postMessage(roomId, roomCode)
    } else {
      window.YiYaJsObj.openRoom(roomId, roomCode)
    }

  } catch (error) {
    window.history.go(-1)
  }
}

// 跳转商城
export const openMall = () => {
  try {
    if (isiOS) {
      window.webkit.messageHandlers.openMall.postMessage('')
    } else {
      window.YiYaJsObj.openMall()
    }
  } catch (error) {
    window.history.go(-1)
  }
}



// 跳转查看个人
export const openPersonDetails = (uid) => {
  try {
    if (isiOS) {
      window.webkit.messageHandlers.openPersonDetails.postMessage({ uid: uid })
    } else {
      window.YiYaJsObj.openPersonDetails(uid)
    }

  } catch (error) {
    window.history.go(-1)
  }
}
// 播放音乐
export const openPlayMusic = (url) => {
  try {
    if (isiOS) {
      window.webkit.messageHandlers.openPlayMusic?.postMessage({ url: url })
    } else {
      window.YiYaJsObj.openPlayMusic(url)
    }

  } catch (error) {
  }
}

